import { UserService } from '../../pages/user/services/user.service';
import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot,RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { LocalService } from '../storage/local.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private readonly router: Router,
    private readonly localService: LocalService,
    private readonly userService: UserService,
    private readonly authService: AuthService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requiredRole = next.data['requiredRole'];
    if (this.authService.isAuthenticated() && this.userService.hasRole(requiredRole)) {
      return true;
    } else {
      this.localService.clearAll();
      this.router.navigate(['']);
      return false;
    }
  }
}

export const AuthGuardService: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AuthGuard).canActivate(next, state);
}
